import { createContext, useContext } from "react";

import { type DragPreviewState } from "../hooks/useDragPreview";

interface DragPreviewContextType {
  dragPreview: DragPreviewState | null;
}

const DragPreviewContext = createContext<DragPreviewContextType>({
  dragPreview: null,
});

export const useDragPreview = () => useContext(DragPreviewContext);

export const DragPreviewProvider = DragPreviewContext.Provider;
